import React from 'react';
import BreakfastWizard from '../components/BreakfastWizard';
import { useNavigate } from 'react-router-dom';

const KahvaltiTakibiPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-[80vh] flex items-center justify-center p-4">
            <BreakfastWizard
                onClose={() => navigate('/dashboard')}
                onComplete={() => navigate('/dashboard')}
            />
        </div>
    );
};

export default KahvaltiTakibiPage;
